import React, { useMemo, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { LoadingScreen } from '../components/ui'
import { getViolationsFromLink } from '../redux/actions'
import { BaseToast } from '../components/ui/tools'
import { withRouter } from 'react-router-dom'
import { linkStorageID } from '../utils/variables'
import log from 'loglevel'

/**
 * Reads from url params to get authentication token, accountID, and user/supervisorID
 * @returns redirect to application if all params are found, if not then redirects to login
 */
const Links = (props) => {
  const dispatch = useDispatch()
  const isLoading = useRef(false)

  const fireResponseMessage = useCallback((response) => {
    const { icon, message, text } = response
    BaseToast(icon, message, text)
  }, [])

  useMemo(() => {
    const getViolationIDs = async () => {
      // isLoading is used to prevent multiple re-renders of the toast, so handle that first
      if (isLoading.current) return
      isLoading.current = true

      if (props.match && props.match.params) {
        const { linkID } = props.match.params
        if (!linkID) {
          log.warn('Could not find params from link')
          fireResponseMessage({ icon: 'error', message: 'Error', text: 'Invalid parameters.' })
          // route to default page
        } else {
          log.info('we have all params')
          log.debug(linkID)
          await dispatch(getViolationsFromLink(linkID, fireResponseMessage))
            .catch(err => console.error(err))
          // If we got the violationIDs successfully, route to detail view
          window.localStorage.removeItem(linkStorageID)
          props.history.push({
            pathname: '/captures',
            search: '?view=single&capture=1'
          })
        }
      }
      // Set is loading to false once everything else has fired
      isLoading.current = false
    }
    getViolationIDs()
  }, [dispatch, props.match, props.history, fireResponseMessage])

  return (<LoadingScreen />)
}

export default withRouter(Links)
